import React, {useEffect, useState, useCallback} from "react";
import './index.scss'
import img_timeup from '@/assets/images/business/time-up/img_timeup.webp'
import img_failed from '@/assets/images/business/time-up/img_failed.webp'
import img_expired from '@/assets/images/business/time-up/img_expired.webp'
import img_istaken from '@/assets/images/business/time-up/img_istaken.webp'
import questionnaire from '@/assets/images/business/light_home_banner_bg.png'
import recommendedPicture from '@/assets/images/business/time-up/expired_recommend_h5.png'
import wishMap from '@/assets/images/business/time-up/expired_wish_list_h5.png'
import ic_apple from '@/assets/images/business/time-up/ic_apple.png'
import ic_android from '@/assets/images/business/time-up/ic_android.png'
import ic_windows from '@/assets/images/business/time-up/ic_windows.png'
import standard from '@/assets/images/business/time-up/standard.png'
import appStore from '@/assets/images/business/time-up/app_store.png'
import googlePlay from '@/assets/images/business/time-up/google_play.png'
import $api from '@/serve/api'
import { useTranslation } from 'react-i18next'
import i18next from "@/utils/i18n.js"
import { isPc, isAndroid, isMac, copyText } from "@/utils/common.js";
import config from "@/config/index"
import { v4 as uuidv4 } from 'uuid'
const pc = isPc()
const android = isAndroid()
const mac = isMac()


// 默认产品信息（保底）
const defaultProductList = [
    {
        id: 1,
        productImage: "https://cdn.lovense.com/resources/img/store/pic-max2.png",
        productName: "Max 2",
        productPage: "https://lovense.com/male-masturbators?_utm_pro=2108132200",
        // productDesc: "High Tech Male Masturbator",
        productDesc: i18next.t('max2_des'),//组件外使用i18n
    },
    {
        id: 2,
        productImage: "https://cdn.lovense.com/resources/img/edge2/edge2.png?v=2",
        productName: "Edge 2",
        productPage:
            "https://lovense.com/adjustable-prostate-massager?_utm_pro=2108133860",
        // productDesc: "Adjustable Prostate Massager",
        productDesc: i18next.t('edge2_des'),
    },
    {
        id: 3,
        productImage: "https://cdn.lovense.com/resources/img/diamo/store1.png",
        productName: "Diamo",
        productPage:
            "https://lovense.com/bluetooth-vibrating-cock-ring?_utm_pro=2108134248",
        // productDesc: "Vibrating Cock Ring",
        productDesc: i18next.t('diamo_des'),
    },
    {
        id: 4,
        productImage: "https://cdn.lovense.com/resources/img/lush3/lush3_1.jpg?v=2",
        productName: "Lush 3",
        productPage:
            "https://lovense.com/bluetooth-remote-control-vibrator?_utm_pro=2108136549",
        // productDesc: "Bluetooth Egg Vibrator",
        productDesc: i18next.t('lush3_des'),
    },
];
const imagesMap = {
    max2: require("@/assets/images/business/time-up/max.png").default,
    lush3: require("@/assets/images/business/time-up/lush3.png").default,
    edge2: require("@/assets/images/business/time-up/edge2.png").default,
    diamo: require("@/assets/images/business/time-up/diamo.png").default,
};

const EndChat = (props) => {
    const { t } = useTranslation();
    const {email: eamil, endType} = props
    const [productList, setProductList] = useState([])
    const [affiliateUrl, setAffiliateUrl] = useState(null)
    const [wishUrl, setWishUrl] = useState(null)
    const [survey, setSurvey] = useState(null)
    const [endData, setEndData] = useState(null)
    useEffect(() => {
        // 获取结束信息
        $api.nhOrderControlLink({eamil}).then(res => {
            if (res.result) {
                const {productList, affiliateUrl, wishUrl} = res.data
                if (productList && productList.length > 0) {
                    productList.forEach((m, index) => {
                        // 去除空格和换行
                        const imageName = m.productName && m.productName
                            .replace(/\s+/g, "")
                            .replace(/<\/?.+?>/g, "")
                            .replace(/[\r\n]/g, "")
                            .toLowerCase()
                        m.productImage =
                            imagesMap[`${imageName}`] ||
                            m.productImage;
                        m.id = index + 1;
                        m.productDesc = defaultProductList[index].productDesc;
                    });
                    setProductList(productList)
                    setAffiliateUrl(affiliateUrl)
                    setWishUrl(wishUrl)
                } else {
                    setProductList(defaultProductList)
                }
            }
        }, err => {
            setProductList(defaultProductList);
        })
        $api.getSurvey().then(res => {
            if (res.result) {
                const { openStatus, onlineUrl } = res.data
                const tapSurvey = localStorage.getItem('tapSurvey')
                if(!tapSurvey && openStatus) setSurvey(onlineUrl)
            }
        })
        $api.getRemoteControlLinkEventResource({
          lang: (navigator.language || navigator.browserLanguage).toLowerCase(),
          creator: false
        }).then(res => {
          if (res.result && res.data) {
            setEndData(res.data)
            let params = {
              "logNo":"M0058",
              "content": JSON.stringify({
                "reason": res.data.eventType,
                "func_type": "Controller",
                "type": res.data.abtestType
              }),
              "timeStamp":new Date().getTime()
            }
            $api.logsNewV2(params)
          }
      })
    }, [eamil])
    const setLogsAndHandleToNewPage = useCallback((e) => {
      if(endData){
        let params = {
          "logNo":"M0059",
          "content": JSON.stringify({
            "reason":endData.eventType,
            "func_type":"Controller",
            "type":endData.abtestType
          }),
          "timeStamp":new Date().getTime()
        }
        $api.logsNewV2(params)
      }
      return (url)=>{
        window.open(url, "_blank");
      }
    },[endData])
    const setLogsAndHandleToVmPage = useCallback((e) => {
      if(endData){
        let params = {
          "logNo":"M0059",
          "content": JSON.stringify({
            "reason":endData.eventType,
            "func_type":"Controller",
            "type":endData.abtestType
          }),
          "timeStamp":new Date().getTime()
        }
        $api.logsNewV2(params)
      }
      return ()=>{
        const uuid = window.sessionStorage.uuid || uuidv4()
        window.sessionStorage.uuid = uuid
        let url = 'blank'
        if(pc){
          copyText(`VibeMate_UTM:54_1_${uuid}`)
          window.open(`https://www.vibemate.com/?utm_id=54&uuid=${uuidv4()}`, "_blank")
          return
        }
        copyText(`VibeMate_UTM:51_1_${uuid}`)
        window.open(`${config.vmUrl}swEvokeVibemate/${url}.html?utm_id=51&uuid=${uuidv4()}`, "_blank")
      }
    },[endData])
    // const handleToMobilePage = useCallback((e) => {
    //   e.stopPropagation()
    //   const copyUrl = `6688 https://www.vibemate.com/UploadFiles/surfease/swEvokeVibemate/swEvokeVibemate.html?code=sharePasteboard&roomUrl=aHR0cHM6Ly93d3cudmliZW1hdGUuY29tL1VwbG9hZEZpbGVzL3N1cmZlYXNlL2ludHJvL2luZGV4Lmh0bWw=&shareId=${uuidv4()}`
    //   copyText(copyUrl)
    //   return (url)=>{
    //       window.open(url, "_blank");
    //   }
    // },[])
    const handleToNewPage = (e) => {
        return (url)=>{
            window.open(url, "_blank");
        }
    }
    const handleToKnowMore = () => {
        window.open(
            "https://lovense.com/bluetooth-wireless-remote-control-sex-toys?_utm_pro=2108136549",
            "_blank"
        );
    }
    const handleToGooglePlay = () => {
        window.open(
            "https://play.google.com/store/apps/details?id=com.lovense.wear",
            "_blank"
        );
    }
    const handleToAppStore = () => {
        window.open(
            "https://apps.apple.com/cn/app/lovense-remote/id1027312824",
            "_blank"
        );
    }

    const imgList = {
        default: img_timeup,
        valid: img_failed,
        banned: img_failed,
        expired: img_expired,
        taken: img_istaken,
    }

    const tipList = {
        default: t('end_page_timesup'),
        over: t('link_auto_end_title'),
        ban: t('link_auto_end_title'),
        valid: t('fail_to_open_link1'),
        banned: t('fail_to_open_link1'),
        expired: t('fail_to_open_link3'),
        taken: t('fail_to_open_link2'),
    }

    let desList = {
        default: t('end_page_timesup_des'),
        over: t('link_auto_end_controllee_des'),
        ban: 'You are banned from opening control links for 30 minutes.',
        valid: t('fail_to_open_link_des3'),
        banned: 'You are banned from opening control links',
        expired: t('fail_to_open_link_des2'),
        taken: t('fail_to_open_link_des1'),
    }

    // 秒转换分秒显示
    const format = (s) => {
        let h = Math.floor(s / 60)
        s = s % 60
        h += ''
        s += ''
        if(h && s!=='0') h = `${h}:${s}`
        return `${h}`
    }

    // 前往问卷
    const toSurvey = (e) => {
        localStorage.setItem('tapSurvey', true)
        if(e) window.location.href = e
        setSurvey(null)
    }

    const getText = (e) => {
        let key = ''
        if(endType){
            key = endType
            if(endType.includes('ban-')){
                let arr = endType.split('-')
                key = arr[0]
                let str = `You are banned from opening control links for ${format(arr[2])} minutes.`
                if(t('link_auto_end_controller_des')) str = t('link_auto_end_controller_des').replace('<#1#>', `${arr[2]} ${t(arr[1])}`)
                desList.ban = str
            }
        }
        return e[key || 'default']
    }

    console.log(`--endType: `, endType);

    return (
        <div className={pc?"pc-end-chat" : "end-chat"}>
            <div className="container">
                <div className="time-up">
                    <img src={imgList[endType  || 'default'] || imgList['default']} alt=""/>
                    <h3>{getText(tipList)}</h3>
                    <p>{getText(desList)}</p>
                </div>
                {survey && <div className="questionnaire">
                    <img className="question-banner" src={questionnaire} alt=""/>
                    <div className="question-text">
                        {t('control_link_survey_title')}
                    </div>
                    <div className="question-tips">
                        {t('control_link_survey_des')}
                    </div>
                    <div className="question-check" onClick={() => { toSurvey(survey) }}>{t('buttonn_survey')}</div>
                </div>}
                {endData && <>
                  {endData.eventType === "vibemate" && <div className="event-img" onClick={(e) => {setLogsAndHandleToVmPage(e)()}}>
                      <img src={endData[pc?'pcBrowserEventImgUrl':'mobileBrowserEventImgUrl']} alt=""/>
                      { pc && endData.eventType === "vibemate" && <div className="event-link">Learn more &gt;</div> }
                  </div>}
                  {endData.eventType !== "vibemate" && <div className="event-img" onClick={(e) => {setLogsAndHandleToNewPage(e)(endData[pc?'pcBrowserEventImgClickUrl':`mobileBrowserClick${android?'Android':'Ios'}Url`])}}>
                      <img src={endData[pc?'pcBrowserEventImgUrl':'mobileBrowserEventImgUrl']} alt=""/>
                  </div>}
                  { pc && endData.eventType === "vibemate" && <div className="event-download">
                    <div className="event-item" onClick={(e) => {setLogsAndHandleToVmPage(e)()}}>
                      <img className="event-icon" src={ic_apple} alt=""/>
                      <div className="event-text">Available on the App Store</div>
                    </div>
                    <div className="event-item" onClick={(e) => {setLogsAndHandleToVmPage(e)()}}>
                      <img className="event-icon" src={ic_android} alt=""/>
                      <div className="event-text">Download for Android</div>
                    </div>
                    <div className="event-item" onClick={(e) => {setLogsAndHandleToNewPage(e)(endData[mac?'pcBrowserClickMacUrl':`pcBrowserClickWindowsUrl`])}}>
                      <img className="event-icon" src={mac?ic_apple:ic_windows} alt=""/>
                      <div className="event-text">Install VibeMate PC</div>
                    </div>
                  </div> }
                </>}
                <div className="interactive">
                    <div className="line"/>
                    <div className="text">
                       <span>
                            {t('end_page_recommend_toys')}
                       </span>
                    </div>
                </div>
                <div className="product-list">
                    <ul>
                        {productList.map((item) => {
                            return (
                                <li key={item.id} onClick={(e) => {handleToNewPage(e)(item.productPage)}}>
                                    <img className="img" src={item.productImage} alt=""/>
                                    <div className="toy-info">
                                        <div>{item.productName}</div>
                                        <p>{item.productDesc}</p>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className="learn-more" onClick={handleToKnowMore}>
                    <span className="text">{t('button_know_more')}</span>
                    <span className="arrow-right"/>
                </div>
                {(affiliateUrl || wishUrl) && (
                    <div className="recommend-list">
                        {affiliateUrl && (
                            <div className="item">
                                <div>{t('end_page_recommended')}</div>
                                <img src={recommendedPicture} alt="" onClick={(e) => { handleToNewPage(e)(affiliateUrl) }}/>
                            </div>
                        )}
                        {wishUrl && (
                            <div className="item">
                                <div>{t('end_page_wishlist_link')}</div>
                                <img src={wishMap} alt="" onClick={(e) => { handleToNewPage(e)(wishUrl) }}/>
                            </div>
                        )}
                    </div>
                )}
                {pc &&  <div className="adv-item">{t('download_remote_des')}</div>}
                <div className="download-area">
                    <div className="left">
                        <img src={standard} alt=""/>
                        <div>Lovense Remote App</div>
                    </div>
                    <div className="right">
                        <img src={appStore} onClick={handleToAppStore} alt=""/>
                        <img src={googlePlay} onClick={handleToGooglePlay} alt=""/>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EndChat;

